// Pure sort helper used by the TaskList. The pair will rarely have more
// than ~50 tasks, so the cost of an in-memory sort is negligible.

export const PRIORITY_RANK = { NONE: 0, LOW: 1, MEDIUM: 2, HIGH: 3 }
export const STATUS_RANK = { TODO: 0, IN_PROGRESS: 1, DONE: 2, CANCELLED: 3 }

export const SORT_FIELDS = ['dueDate', 'priority', 'status', 'assignee', 'age']

export function sortTasks(tasks, field, direction = 'asc') {
  const copy = [...tasks]
  copy.sort((a, b) => {
    let cmp = 0
    switch (field) {
      case 'dueDate':
        // Tasks with due dates come first, sorted by date.
        // Tasks without due dates come last, sorted by createdAt as a tie-break.
        if (a.dueDate && !b.dueDate) cmp = -1
        else if (!a.dueDate && b.dueDate) cmp = 1
        else if (a.dueDate && b.dueDate) cmp = a.dueDate.localeCompare(b.dueDate)
        else cmp = (a.createdAt ?? '').localeCompare(b.createdAt ?? '')
        break
      case 'priority':
        // High first, so reverse the natural numeric order.
        cmp = -(PRIORITY_RANK[a.priority] ?? 0) + (PRIORITY_RANK[b.priority] ?? 0)
        break
      case 'status':
        cmp = (STATUS_RANK[a.status] ?? 0) - (STATUS_RANK[b.status] ?? 0)
        break
      case 'assignee':
        cmp = (a.assignee ?? '').localeCompare(b.assignee ?? '')
        break
      case 'age':
        cmp = (a.createdAt ?? '').localeCompare(b.createdAt ?? '')
        break
      default:
        cmp = 0
    }
    return direction === 'asc' ? cmp : -cmp
  })
  return copy
}
